<template>
    <div class="left-nav">
        <div class="nav-list">
            <div class="nav-item" :class="{'active': navactive == i}" v-for="(item, i) in navlist" :key="i" @click="navchange(i)">
                <img :src="getimg(item.icon)" alt="">
                <div class="text">{{ item.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navlist: [
                { name: '账号设置', icon: 'home.png', path: 'human' },
                { name: '我的订单', icon: 'order.png', path: 'order' },
            ],
            navactive: 0
        }
    },
    methods: {
        getimg(url) {
            return require(`@/assets/human/${url}`)
        },
        navchange(i) {
            if (i == this.navchange) return
            this.navactive = i
            this.$emit('navchange', this.navlist[i].path)
        },
        setActive() {
            let route = this.$route.query
            if (!Object.keys(route).length) {
                this.navactive = 0
            } else if (route.path) {
                let npath = this.navlist.findIndex(item => item.path == route.path)
                if (npath !== -1) {
                    this.navactive = npath
                } else {
                    this.navactive = 0
                }
            }
            let select = this.navlist[this.navactive]
            this.$emit('temload', select.path)
        }
    },
    mounted() {
        this.setActive()
    }
}
</script>

<style lang="scss">
.left-nav {
    width: 276px;
    height: 100%;
    background: #fff;
    .nav-list {
        margin: 32px auto;
    }
    .nav-item {
        display: flex;
        align-items: center;
        padding: 18px 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 18px;
        color: #A0A2AB;
        cursor: pointer;
        margin: 0 18px;
        transition: all 0.3s linear;
        &:hover,
        &.active {
            color: #414B5E;
            background: #F7F7F7;
            border-radius: 10px;
        }
        img {
            width: 18px;
            height: 20px;
            margin-right: 16px;
        }
        & + .nav-item {
            margin-top: 12px;
        }
    }
}
</style>